import React, { Component } from 'react';

class QuizForm extends Component {
    render() {
        const handleSubmit = this.props.handleSubmit;
        const handleChange = this.props.handleChange;
        const state = this.props.state;
        return(
            <div className = {`QuizForm container bg-white p-4 mt-5 rounded ${state.formCompleted ? 'form-hidden' : 'form-shown'}`}>
                <form onSubmit ={handleSubmit}>
                    <h1 className = "h3 text-muted text-center">Fill this form to play our Quiz</h1>
                    <hr/>
                    <div className="form-group mt-5">
                        <label htmlFor="amount" className ="pr-5">Number of Questions</label>
                        <input 
                        type = "number" 
                        name = "amount"
                        min ="5"
                        max ="50"
                        value = {state.amount}
                        onChange = {handleChange}
                        className = "input-field"
                        required
                        />
                    </div>
                    <div className="form-group mt-5">
                        <label htmlFor="category">Category</label>
                        <select 
                        className="form-control input-field"
                        value = {state.category}
                        onChange = {handleChange}
                        name ="category"
                        >
                            <option value="any">Any Category</option>
                            <option value="9">General Knowledge</option>
                            <option value="10">Entertainment: Books</option>
                            <option value="11">Entertainment: Film</option>
                            <option value="12">Entertainment: Music</option>
                            <option value="13">Entertainment: Musicals &amp; Theatres</option>
                            <option value="14">Entertainment: Television</option>
                            <option value="15">Entertainment: Video Games</option>
                            <option value="16">Entertainment: Board Games</option>
                            <option value="17">Science &amp; Nature</option>
                            <option value="18">Science: Computers</option>
                            <option value="19">Science: Mathematics</option>
                            <option value="20">Mythology</option>
                            <option value="21">Sports</option>
                            <option value="22">Geography</option>
                            <option value="23">History</option>
                            <option value="24">Politics</option>
                            <option value="25">Art</option>
                            <option value="26">Celebrities</option>
                            <option value="27">Animals</option>
                            <option value="28">Vehicles</option>
                            <option value="29">Entertainment: Comics</option>
                            <option value="30">Science: Gadgets</option>
                            <option value="31">Entertainment: Japanese Anime &amp; Manga</option>
                            <option value="32">Entertainment: Cartoon &amp; Animations</option>
                        </select>
                    </div>
                    <div className="form-group mt-5">
                        <label htmlFor="difficulty">Difficulty</label>
                        <select 
                        className="form-control input-field"
                        value = {state.difficulty}
                        onChange = {handleChange}
                        name ="difficulty"
                        >
                            <option value = "any">Any</option>
                            <option value="easy">Easy</option>
                            <option value="medium">Medium</option>
                            <option value="hard">Hard</option>
                        </select>
                    </div>
                    <div className="form-group mt-5">
                        <label htmlFor="type">Type of Questions</label>
                        <select 
                            className="form-control input-field"
                            value = {state.type}
                            onChange = {handleChange}
                            name ="type"
                            >
                            <option value = "any">Any</option>
                            <option value="multiple">Multiple Choice</option>
                            <option value="boolean">True/False</option>
                            </select>
                    </div>
                    <button type ="submit" className = "btn btn-secondary submit-button mt-3">Submit</button>
                    </form>
            </div>
        )
    }  
}

export default QuizForm;